import React from 'react';
import './Select.css';

export function Select({ label, children, ...props }) {
  return (
    <label className="select-label">
      {label && <span>{label}</span>}
      <select className="styled-select" {...props}>
        {children}
      </select>
    </label>
  );
}

export default Select;